import { SheetType } from '../../types/enums/SheetType';
import { 
  Sheet,
  Carac,
  SheetCarac,
  ProjectSheet,
 } from '../../types/noocoDbTypes';
import { User } from '../../types/noocoDbTypes';
import * as general from '../general';

export interface ProjectSheetWithSheetAndCaracs extends ProjectSheet {
  Sheet: SheetWithCarac;
  Caracs: Carac[];
}

export interface CaracWithSheetCarac extends Carac {
  SheetCarac: SheetCarac;
}

export interface SheetWithCarac extends Sheet {
  Caracs?: CaracWithSheetCarac[];
}

export interface ProjectHistoryGetRequest {
  id: number;
  Body: ProjectHistoryGetBody;
}

export interface ProjectHistoryGetBody {
  limit?: number;
  offset?: number;
  minDate?: Date;
  maxDate?: Date;
  search?: string;
}

export type ActionTypeMap = {
  ImportActionType: ImportActionType;
  AddContributorActionType: AddContributorActionType;
  DeleteContributorActionType: DeleteContributorActionType;
  ModifyContributorActionType: ModifyContributorActionType;
  ModifyCalculatorActionType: ModifyCalculatorActionType;
};

type Username = Pick<User, 'firstName' | 'lastName'>;

interface CaracState {
  name: string;
  value: string;
  unit: string | null;
}

interface StoredCaracState extends Pick<CaracState, "unit" | "value"> {
  NameContentId: number,
  intValue: number | null,
};

export interface StoredContributorState extends Omit<ContributorState, "caracsState"> {
  SheetId: number;
  ProjectSheetId: number;
  Unit: {
    id: number;
    name: string;
  };
  originalName: string;
  storedCaracsState: StoredCaracState[];
};

interface ContributorState {
  quantity: number;
  quantityUnit: string;
  customName: string | null;
  sheetName: string;
  sheetType: SheetType;
  caracsState: CaracState[];
}

export interface DeleteContributorActionType extends ActionData {
  deletedState: ContributorState;
}

export interface AddContributorActionType extends ActionData {
  addedState: ContributorState;
}

export interface ModifyContributorActionType extends ActionData {
  previousState: ContributorState;
  updatedState: ContributorState;
}

export interface ModifyCalculatorActionType extends ActionData {}

export interface ImportActionType extends ActionData {
  fileName: string;
  importLineCount: number;
}

interface ActionData {
  user: Username;
  actionType: keyof ActionTypeMap;
  date: Date;
}

export interface ProjectHistory {
  actions: (
    | ImportActionType
    | AddContributorActionType
    | DeleteContributorActionType
    | ModifyContributorActionType
    | ModifyCalculatorActionType
  )[];
  count: number;
  minDate: Date;
  maxDate: Date;
}

export function getProjectHistorySuccess(projectHistory: ProjectHistory): general.SuccessReturnBody {
  return general.getSuccessReturnBody(projectHistory);
}